/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityStatsRiskScoreV2
 */
export interface MonitEntityStatsRiskScoreV2 {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsRiskScoreV2
     */
    risk_score_v2?: number;
}

/**
 * Check if a given object implements the MonitEntityStatsRiskScoreV2 interface.
 */
export function instanceOfMonitEntityStatsRiskScoreV2(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsRiskScoreV2FromJSON(json: any): MonitEntityStatsRiskScoreV2 {
    return MonitEntityStatsRiskScoreV2FromJSONTyped(json, false);
}

export function MonitEntityStatsRiskScoreV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsRiskScoreV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'risk_score_v2': !exists(json, 'risk_score_v2') ? undefined : json['risk_score_v2'],
    };
}

export function MonitEntityStatsRiskScoreV2ToJSON(value?: MonitEntityStatsRiskScoreV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'risk_score_v2': value.risk_score_v2,
    };
}

